module.exports = __webpack_public_path__ + "img/nophoto.decc52c7.jpg";